export const selectItemsList = (state) => state.itemManage.items;
export const selectBranchList = (state) => state.itemManage.branches;
export const selectItemCategories = (state) => state.itemManage.categories;
export const selectItemRacks = (state) => state.itemManage.racks;
export const selectItemModels = (state) => state.itemManage.models;
export const selectItemOrigins = (state) => state.itemManage.origins;
export const selectItemUnits = (state) => state.itemManage.units;
export const selectItemManageItemCode = (state) => state.itemManage.itemCode;

export const selectSelectedItem = (state) => state.itemManage.selectedItem;
export const selectIsEditItem = (state) => state.itemManage.isEditItem;

export const selectItemManageLoading = (state) => state.itemManage.loading;
export const selectItemManageError = (state) => state.itemManage.error;
export const selectItemManageSuccessMessage = (state) => state.itemManage.successMessage;

export const selectItemManufactures = (state) => state.itemManage.manufactures;
export const selectItemDistributors = (state) => state.itemManage.distributors;
export const selectGenericNames =
  (state) => state.itemManage.genericNames;